var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    {
      staticClass: "club-discount-banner cursor-pointer",
      attrs: { "data-qa": "club_discount_banner" },
      on: {
        click: function ($event) {
          return _setup.emit("click")
        },
      },
    },
    [
      _c(
        "div",
        {
          staticClass:
            "d-flex align-center justify-space-between club-discount-banner__inner",
        },
        [
          _c(
            "div",
            {
              staticClass:
                "d-flex align-center gc-2 text-body-1 text-secondary--text",
            },
            [
              _vm._v("\n      🔥\n      "),
              _c(
                "span",
                {
                  staticClass: "text-error--text text-subtitle-1",
                  attrs: {
                    "data-qa": "club_discount_banner_club_discount_price",
                  },
                },
                [_vm._v("-" + _vm._s(_setup.clubDiscountPrice))]
              ),
              _vm._v("\n      по клубной цене\n    "),
            ]
          ),
          _vm._v(" "),
          _c("div", {
            staticClass: "ui-icon-arrow-right text-error--text ml-auto",
          }),
        ]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }